module.exports = __webpack_public_path__ + "static/media/uba.2e7cf0e1.svg";